import { apiClient } from './client';

export function listReports (shopId: number | string) {
  return apiClient.get(`/${shopId}/shop/reports`);
}

export function getReport (shopId: number | string, slug: string, params: { type: string; start: string; end: string }) {
  return apiClient.get(`/${shopId}/shop/reports/${slug}`, { params });
}

export function exportReport (shopId: number | string, slug: string, params: { type: string; start: string; end: string }) {
  return apiClient.get(`/${shopId}/shop/reports/${slug}/export`, { params: { ...params, isExport: true } });
}
